export const dateAtMidnight = (date: Date) => {
    const result = new Date(date);
    result.setUTCHours(0, 0, 0, 0);

    return result;
};

export const addDays = (date: Date, days = 1) => {
    const result = new Date(date);
    result.setUTCDate(result.getDate() + days);
    return result;
};

export const intervalInDays = (date1: Date, date2: Date): number => {
    const secondsInterval = date2.getTime() - date1.getTime();
    const dayInterval = secondsInterval / (1000 * 3600 * 24);
    return dayInterval;
};